import { useEffect, useState } from "react";

const GamePlayXSmall = import(`../../assets/backgrounds/gameplay-${window.TENANT}-xsmall.webp`);
const GamePlaySmall = import(`../../assets/backgrounds/gameplay-${window.TENANT}-small.webp`);
const GamePlayMedium = import(`../../assets/backgrounds/gameplay-${window.TENANT}-medium.webp`);
const GamePlayLarge = import(`../../assets/backgrounds/gameplay-${window.TENANT}-large.webp`);
const GamePlayXLarge = import(`../../assets/backgrounds/gameplay-${window.TENANT}-xlarge.webp`);
const GamePlayXXLarge = import(`../../assets/backgrounds/gameplay-${window.TENANT}-xxlarge.webp`);

const useController = () => {
	const [bgImage, setBgImage] = useState(null);
	const [bgSize, setBgSize] = useState(null);

	useEffect(() => {
		const loadImage = async () => {
			const screenWidth = window.innerWidth;

			if (screenWidth < 425) {
				const module = await GamePlayXSmall;
				setBgImage(module.default);
				setBgSize("425px 610px");
			} else if (screenWidth >= 425 && screenWidth < 768) {
				const module = await GamePlaySmall;
				setBgImage(module.default);
				setBgSize("768px 850px");
			} else if (screenWidth >= 768 && screenWidth < 1024) {
				const module = await GamePlayMedium;
				setBgImage(module.default);
				setBgSize("1024px 840px");
			} else if (screenWidth >= 1024 && screenWidth < 1440) {
				const module = await GamePlayLarge;
				setBgImage(module.default);
				setBgSize("1440px 560px");
			} else if (screenWidth >= 1440 && screenWidth < 1600) {
				const module = await GamePlayXLarge;
				setBgImage(module.default);
				setBgSize("1600px 770px");
			} else if (screenWidth >= 1600) {
				const module = await GamePlayXXLarge;
				setBgImage(module.default);
				setBgSize("2400px 800px");
			}
		};

		loadImage().catch((error) => console.error("Error loading background image:", error));
	}, []);

	return { state: { bgImage, bgSize } };
};

export default useController;
